import { useMemo } from 'react';
import { BreadcrumbComponentType } from 'use-react-router-breadcrumbs';

import { useBreadcrumbDomainRegistrarQuery } from '../../DomainRegistrars';
import { DynamicBreadcrumbWrapper } from './DynamicBreadcrumbWrapper';

const DynamicDomainRegistrarsByIdBreadcrumb: BreadcrumbComponentType<'domainRegistrarId'> = ({ match }) => {
  const domainRegistrarId = useMemo(() => match.params.domainRegistrarId ?? '', [match.params.domainRegistrarId]);

  const breadcrumbQuery = useBreadcrumbDomainRegistrarQuery(domainRegistrarId)();

  return <DynamicBreadcrumbWrapper { ...breadcrumbQuery }/>;
};

const DynamicDomainRegistrarsListBreadcrumb: BreadcrumbComponentType = () => {
  return <span>Реєстратори доменів</span>;
};

export const DynamicDomainRegistrarsBreadcrumb = {
  DynamicDomainRegistrarsListBreadcrumb,
  DynamicDomainRegistrarsByIdBreadcrumb
};
